import React, { useId } from "react";
import {
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const NO_DESCRIPTION_TEXT = "No rule description provided.";

/**
 * Displays the read-only Other Details view for a rule unit.
 */
export default function ViewOtherInfo({
  open,
  onClose,
  title = "Other Details",
  ruleUnit,
}) {
  const titleId = useId();
  const descriptionId = useId();

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      aria-labelledby={titleId}
      aria-describedby={descriptionId}
    >
      <DialogTitle sx={{ px: 3, pt: 2, pb: 1 }}>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Typography id={titleId} variant="h6" component="div">
            {title}
          </Typography>
          <IconButton onClick={onClose} aria-label="close">
            <CloseIcon />
          </IconButton>
        </Box>
      </DialogTitle>
      <DialogContent dividers sx={{ px: 3, py: 2.5 }}>
        <Typography
          variant="body1"
          sx={{ fontWeight: "bold", textAlign: "left", mb: 1.5 }}
        >
          Rule Description:
        </Typography>
        <Box
          id={descriptionId}
          sx={{
            minHeight: 160,
            p: 1,
            border: "1px solid",
            borderColor: "divider",
            borderRadius: 1,
            backgroundColor: "background.paper",
          }}
        >
          <Typography
            variant="body2"
            sx={{ whiteSpace: "pre-wrap", wordBreak: "break-word" }}
          >
            {ruleUnit?.ruleDescription || NO_DESCRIPTION_TEXT}
          </Typography>
        </Box>
      </DialogContent>
    </Dialog>
  );
}
